import * as React from 'react';

import Icon from '../../Icon';
import Clear from '../../Clear';
import Checkbox from '../../CheckBox';

export default class Filter extends React.Component {
  constructor(props) {
    super(props);
    let currentAppliedFilters = this.props.choices
      .filter((el) => {
        return el.is_selected === true;
      })
      .map((el) => {
        return el.value;
      });
    this.state = { isOpened: false, filtersQuery: [...currentAppliedFilters] };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.overlayVisible === false) {
      this.setState({
        isOpened: nextProps.overlayVisible,
      });
    }
  }

  toggleFilterBody() {
    this.setState({
      isOpened: !this.state.isOpened,
    });
    this.props.overlay(!this.state.isOpened);
  }

  toggleFiltersQuery(value, checked) {
    this.setState(
      (prevState) => ({
        filtersQuery: value,
      }),
      () => {
        this.applyFilterQuery();
      }
    );
    this.props.overlay(false);
  }

  renderFilterBodyItems(choices) {
    return choices.map((choice, index) => {
      return (
        <div className='item' key={index}>
          <Checkbox
            name='filter'
            icon='check'
            checked={choice.is_selected}
            value={choice.value}
            onChange={(checked) =>
              this.toggleFiltersQuery(choice.value, checked)
            }
          >
            <span className='float-left'>
              {choice.label} <em>({choice.quantity})</em>
            </span>
          </Checkbox>
        </div>
      );
    });
  }

  applyFilterQuery() {
    this.props.applyFilterQuery(this.state.filtersQuery);
  }

  render() {
    let { isOpened } = this.state;
    let { title, iconClosed, iconOpened, choices } = this.props;
    return (
      <div
        className={'filter ' + (isOpened ? 'opened' : '')}
        onClick={(e) => {
          e.preventDefault();
          this.toggleFilterBody();
        }}
      >
        <span className='title'>{title}</span>
        {!isOpened && iconClosed ? <Icon icon={iconClosed} /> : ''}
        {isOpened && iconOpened ? <Icon icon={iconOpened} /> : ''}
        <div className='body'>
          <div className='body-inner'>
            {this.renderFilterBodyItems(choices)}
          </div>
          <Clear />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/product/list/Filter.js